import { templateBaseurl } from 'services/http';
export const messageServiceEndpoints = {

	getTemplatesByRole : `${templateBaseurl}/getTemplateRoleMapping`,
    updateMapping :  `${templateBaseurl}/updateTemplateRoleMapping`,
	updateRoleMapping :  `${templateBaseurl}/copyTemplateRoleMapping`,
    allCategory : `${templateBaseurl}/getAllTemplateCategory`,
    	///destination
	destinationType: {
		getAll: `${templateBaseurl}/getAllTemplateDestinationType`
	}
};
